import React, { createContext, useContext, useEffect, useState } from 'react';
import SocketClient, { CONNECTION_STATES } from '../socket';

const Context = createContext({
  socket: null,
  isConnected: false,
  status: 'disconnected',
});

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [connectionState, setConnectionState] = useState(
    SocketClient.getConnectionState() || 'disconnected',
  );

  useEffect(() => {
    let mounted = true;
    const init = async () => {
      const userSocket = await SocketClient.getSocket();
      if (mounted) {
        setSocket(userSocket);
        setConnectionState(SocketClient.getConnectionState());
      }
    };
    init();
    const unsubscribe = SocketClient.onStateChange((state) => {
      if (mounted) {
        setConnectionState(state);
      }
    });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  const isConnected = connectionState === CONNECTION_STATES.CONNECTED;
  const states = {
    socket,
    isConnected,
    connectionState,
  };

  return <Context.Provider value={states}>{children}</Context.Provider>;
}

export function useSocket() {
  return useContext(Context);
}
